
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { FaVideo, FaMicrophone, FaPercent} from "react-icons/fa";
import { FiPhone } from "react-icons/fi";
import VideoCallRomRandomConfig from "../components/ConformModel/VideoCallRomRandomConfig";
import ChartConfig from "../components/ConformModel/ChartConfig";
import {
  useToast,
} from '@chakra-ui/react';
const CallConfig = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const adminUser = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("adminUser") || "{}");
    } catch {
      return {};
    }
  }, []);

  const isAuthorized = useMemo(() => {
    const allowedEmails = ["admin@cockroach.in","admin@arrowcoders.com", "haravindh@arrowcoders.com"];
    return allowedEmails.includes(adminUser?.email?.toLowerCase());
  }, [adminUser]);

  const [config, setConfig] = useState({
    videoCallCoinsPerMin: 0,
    audioCallCoinsPerMin: 0,
    chatCoinsPerMin: 0,
    adminCommissionPercentage: 0,
    AudioVoiceChatPerMessage: 0,
    giftAdminCommissionPercentage: 0, 
     referrerBonusCoins: 0,
    refereeBonusCoins: 0,
    videoCallAdminCommissionPercentage:0,
audioCallAdminCommissionPercentage:0,
  });
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const toast = useToast();

  useEffect(() => {
    fetchConfig();
  }, []);


  

  const fetchConfig = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/v1/app/call-config");
      if (res.data.status === "OK" && res.data.data?.callConfig) {
        setConfig(res.data.data.callConfig);
      }

      // 🎁 Fetch gift commission
const giftRes = await axios.get("/api/v2/admin/giftConfig");

if (giftRes.data.status === "OK") {
  setConfig(prev => ({
    ...prev,
    giftAdminCommissionPercentage:
      giftRes.data.data.adminCommissionPercentage
  }));
}



    } catch (error) {
      console.error("Error fetching call config:", error);
        toast({
        title: "Error loading configuration!",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
     
    } finally {
      setLoading(false);
    }
  };


  const handleInputChange = (field, value) => {
    const numericFields = [
      "videoCallCoinsPerMin",
      "audioCallCoinsPerMin",
      "chatCoinsPerMin",
      "adminCommissionPercentage",
      "referrerBonusCoins",
      "refereeBonusCoins",
      "AudioVoiceChatPerMessage",
       "videoCallAdminCommissionPercentage",
  "audioCallAdminCommissionPercentage",
      "giftAdminCommissionPercentage",
      "referrerBonusCoins",
    "refereeBonusCoins"
    ];
    if (numericFields.includes(field)) {
      const numValue = value === "" ? "" : parseFloat(value);
      setConfig((prev) => ({ ...prev, [field]: numValue }));
    } else {
      setConfig((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      if (!config.videoCallCoinsPerMin || !config.audioCallCoinsPerMin || !config.chatCoinsPerMin) {
         toast({
        title: "All call rates are required",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
       
        return;
      }
      // if (config.adminCommissionPercentage < 0 || config.adminCommissionPercentage > 100) {
      //      toast({
      //   title: "Commission must be between 0 and 100",
      //   status: "error",
      //   duration: 3000,
      //   isClosable: true,
      // });
      //   return;
      // }

      if (
  config.videoCallAdminCommissionPercentage < 1 ||
  config.videoCallAdminCommissionPercentage > 100 ||
  config.audioCallAdminCommissionPercentage < 1 ||
  config.audioCallAdminCommissionPercentage > 100
) {
  toast({
    title: "Commission must be between 1 and 100",
    status: "error",
    duration: 3000,
    isClosable: true,
  });
  return;
}

      const res = await axios.put("/api/v1/app/call-config", config);

       // 🎁 Save gift config
      await axios.put("/api/v2/admin/giftConfig", {
        adminCommissionPercentage:config.giftAdminCommissionPercentage,
      });

      if (res.data.status === "OK") {
        setConfig(res.data.data.callConfig);
        
         toast({
        title: "Configuration updated successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      } else {
         
      //    toast({
      //   title: "Error saving configuration!",
      //   status: "error",
      //   duration: 3000,
      //   isClosable: true,
      // });
       
      }
    } catch (error) {
      console.error("Error saving config:", error);
      //  toast({
      //   title: "Error saving configuration!",
      //   status: "error",
      //   duration: 3000,
      //   isClosable: true,
      // });
      
    } finally {
      setSaving(false);
    }
  };

  if (!isAuthorized) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center p-8 bg-white rounded-xl shadow-lg border-2 border-red-100 max-w-md">
          <div className="text-red-500 text-5xl mb-4 flex justify-center">
            <FiPhone />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Access Restricted</h2>
          <p className="text-gray-600">
            You do not have permission to access the Call Configuration page. 
            Please contact the super administrator if you believe this is an error.
          </p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64 bg-[var(--black)]">
        <div className="w-8 h-8 rounded-full animate-spin border-4 border-[color:var(--yellow)/0.25] border-t-[var(--yellow)]" />
      </div>
    );
  }

  return (
    <div className="p-6 bg-[var(--black)] min-h-screen text-[var(--yellow)]">
      <div className="max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold mb-6 flex items-center gap-2 text-[var(--yellow)]">
        <FaVideo className="text-[var(--yellow)]" />
        Call Configuration / RandomCall Configuration
      </h1>

      {message && (
        <div
          className={`mb-6 p-3 rounded-lg text-sm font-medium border-2 ${
            messageType === "error"
              ? "bg-[color:var(--yellow)/0.12] text-[var(--yellow)] border-gray-300"
              : "bg-[var(--yellow)] text-[var(--black)] border-gray-300"
          }`}
        >
          {message}
        </div>
      )}

      {/* Stats Section */}
      <div className="grid sm:grid-cols-1 lg:grid-cols-3 gap-4 mb-8">
        <div className="bg-gradient-to-br from-[var(--yellow)]/10 to-[var(--yellow)]/5 border-2 border-[var(--yellow)]/20 rounded-xl p-4 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-[color:var(--yellow)/0.8] uppercase tracking-wider">
                Video Calls
              </p>
              <p className="text-2xl font-bold text-[var(--yellow)]">
                {config.videoCallCoinsPerMin}
              </p>
              <p className="text-xs text-[color:var(--yellow)/0.7] mt-1">coins per minute</p>
            </div>
            <div className="text-3xl text-[var(--yellow)]">
              <FaVideo />
            </div>
          </div>
        </div>



        <div className="bg-gradient-to-br from-green-500/10 to-green-500/5 border-2 border-green-500/20 rounded-xl p-4 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-green-400 uppercase tracking-wider">
                Audio Calls
              </p>
              <p className="text-2xl font-bold text-green-400">
                {config.audioCallCoinsPerMin}
              </p>
              <p className="text-xs text-green-300 mt-1">coins per minute</p>
            </div>
            <div className="text-3xl text-green-400">
              <FaMicrophone />
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-2 border-blue-500/20 rounded-xl p-4 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-blue-400 uppercase tracking-wider">
                Commission
              </p>
              <p className="text-2xl font-bold text-blue-400">
                {config.adminCommissionPercentage}%
              </p>
              <p className="text-xs text-blue-300 mt-1">platform fee</p>
            </div>
            <div className="text-3xl text-blue-400">
              <FaPercent />
            </div>
          </div>
        </div>
      </div>

      {/* Update Pricing Section */}
      <div className="bg-[var(--black)] rounded-xl p-6 border-2 border-gray-300 mb-8 w-full">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2 text-[var(--yellow)]">
          <FaPercent className="text-[var(--yellow)]" /> Update Pricing
        </h2>
        <p className="text-sm text-[color:var(--yellow)/0.85] mb-4">
          Set the coin cost per minute for different communication features
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
  <label className="text-sm font-medium text-[color:var(--yellow)/0.9]">
    Referrer Bonus Coins
  </label>

  <input
    type="number"
    min="0"
    value={config.referrerBonusCoins}
    onChange={(e) =>
      handleInputChange("referrerBonusCoins", e.target.value)
    }
    className="mt-1 w-full border-2 border-gray-300 rounded-lg p-2 bg-[var(--black)] text-[var(--yellow)]"
  />
</div>
<div>
  <label className="text-sm font-medium text-[color:var(--yellow)/0.9]">
    Referee Bonus Coins
  </label>

  <input
    type="number"
    min="0"
    value={config.refereeBonusCoins}
    onChange={(e) =>
      handleInputChange("refereeBonusCoins", e.target.value)
    }
    className="mt-1 w-full border-2 border-gray-300 rounded-lg p-2 bg-[var(--black)] text-[var(--yellow)]"
  />
</div>
          <div>
            <label className="text-sm font-medium text-[color:var(--yellow)/0.9]">Video Call Coins/Min</label>
            <input
              type="number"
              value={config.videoCallCoinsPerMin}
              onChange={(e) => handleInputChange("videoCallCoinsPerMin", e.target.value)}
              className="mt-1 w-full border-2 border-gray-300 rounded-lg p-2 bg-[var(--black)] text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-[color:var(--yellow)/0.9]">Audio Call Coins/Min</label>
            <input
              type="number"
              value={config.audioCallCoinsPerMin}
              onChange={(e) => handleInputChange("audioCallCoinsPerMin", e.target.value)}
              className="mt-1 w-full border-2 border-gray-300 rounded-lg p-2 bg-[var(--black)] text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
            />
          </div>


          <div>
            <label className="text-sm font-medium text-[color:var(--yellow)/0.9]">Video Call Commission %</label>
            <input
              type="number"
              value={config.videoCallAdminCommissionPercentage}
              onChange={(e) => handleInputChange("videoCallAdminCommissionPercentage", e.target.value)}
              className="mt-1 w-full border-2 border-gray-300 rounded-lg p-2 bg-[var(--black)] text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
            />
          </div>


          <div>
            <label className="text-sm font-medium text-[color:var(--yellow)/0.9]">Audio Call Commission %</label>
            <input
              type="number"
              value={config.audioCallAdminCommissionPercentage}
              onChange={(e) => handleInputChange("audioCallAdminCommissionPercentage", e.target.value)}
              className="mt-1 w-full border-2 border-gray-300 rounded-lg p-2 bg-[var(--black)] text-[var(--yellow)] focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6]"
            />
          </div>

          <div>
        
<div>
  <label className="text-sm font-medium text-[color:var(--yellow)/0.9]">
    Gift Commission %
  </label>
  <input
    type="number"
    value={config.giftAdminCommissionPercentage}
    onChange={(e) =>
      handleInputChange(
        "giftAdminCommissionPercentage",
        e.target.value
      )
    }
    className="mt-1 w-full border-2 border-gray-300 rounded-lg p-2 bg-[var(--black)] text-[var(--yellow)]"
  />
</div>



          </div>




        </div>

        <button
          onClick={handleSave}
          disabled={saving}
          className="mt-6 px-6 py-3 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-[var(--yellow)] text-[var(--black)]"
        >
          {saving ? "Saving..." : "Save Configuration"}
        </button>
      </div>

      {/* <VideoCallRomRandomConfig /> */}

      <ChartConfig/>

      {/* How Call Pricing Works Section */}
      <div className="bg-[var(--black)] border-2 border-[color:var(--yellow)/0.08] rounded-xl p-5 text-sm">
        <h3 className="font-semibold text-[var(--yellow)] text-2xl mb-4">How Call Pricing Works</h3>
        <ul className="list-disc list-inside space-y-1 text-[color:var(--yellow)/0.95]">
          <li><strong className="text-[var(--yellow)]">Video Calls:</strong> Premium feature with highest coin cost per minute</li>
          <li><strong className="text-[var(--yellow)]">Audio Calls:</strong> Standard voice communication with moderate pricing</li>
          <li><strong className="text-[var(--yellow)]">Chat:</strong> Basic text messaging with lowest coin cost</li>
          <li><strong className="text-[var(--yellow)]">Admin Commission:</strong> Platform fee percentage taken from each transaction</li>
          <li><strong className="text-[var(--yellow)]">Users are charged automatically</strong> based on call usage time</li>
          <li><strong className="text-[var(--yellow)]">Configuration changes</strong> apply immediately to new calls</li>
        </ul>
      </div>
      </div>
    </div>
  );
};

export default CallConfig;

